import { popularVideos } from '@/mocks/home';
import { Link } from 'react-router-dom';

export default function PopularVideosSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              热门视频
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              大家都在看
            </h2>
          </div>
          <Link
            to="/category/trending"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {popularVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group cursor-pointer"
            >
              <div className="relative rounded-2xl overflow-hidden mb-3 aspect-[3/4] bg-background-200">
                <img
                  src={video.cover}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`91short热门视频 - ${video.title}`}
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <span className="text-background-50 text-xs font-medium bg-black/40 px-2.5 py-1 rounded-md">
                    <i className="ri-play-fill mr-1"></i>
                    {video.views}播放
                  </span>
                </div>
                <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm text-background-50 text-xs px-2 py-1 rounded-md">
                  {video.duration}
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 leading-snug line-clamp-2 mb-1.5 group-hover:text-primary-600 transition-colors">
                {video.title}
              </h3>
              <p className="text-xs text-foreground-500 flex items-center gap-1">
                <span>@{video.author}</span>
                <span className="text-foreground-300">·</span>
                <span><i className="ri-heart-line mr-0.5"></i>{video.likes}</span>
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}